import { AHButton, AHInput, AHSeparator, Box, useLayoutContext } from "arkh";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql, useMutation } from "react-relay";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { useKeyboard } from "../../../OS/useKeyboard";
import { KPIEditScreenProps } from "./KPIEditParamList";

export function KPIEditTitle(props: KPIEditScreenProps<"KPIEditTitle">) {
  const insets = useSafeAreaInsets();
  const keyboard = useKeyboard();
  const layout = useLayoutContext();
  const intl = useIntl();
  const intl_token = useIntlTokens();
  const [title, setTitle] = useState(props.route.params.title);
  const [updateTitle, loading] = useMutation(graphql`
    mutation KPIEditTitleMutation($routineId: ID!, $title: String!) {
      routine(id: $routineId) {
        update(input: { setTitle: $title }) {
          routine {
            id
            title
          }
        }
      }
    }
  `);

  const onUpdateTitle = useCallback(() => {
    updateTitle({
      variables: {
        routineId: props.route.params.routineId,
        title,
      },
      onCompleted: () => {
        props.navigation.goBack();
      },
    });
  }, [props.navigation, props.route.params.routineId, title, updateTitle]);

  return (
    <Box
      style={{ flex: 1, justifyContent: "space-between" }}
      insets={{
        bottom: Math.max(
          keyboard.availableRect.bottom,
          Math.max(insets.bottom, layout.space.large)
        ),
      }}
    >
      <Box spaceHorizontal="medium" spaceTop="medium">
        <AHInput
          placeholder={intl.formatMessage({
            defaultMessage: "KPI name",
            description: "KPIAdminEditTitle description",
          })}
          numberOfLines={1}
          color="surface"
          textType="list-item-title"
          autoFocus
          cornerRadius="large"
          space="medium"
          autoCapitalize="sentences"
          returnKeyType="none"
          onChangeText={setTitle}
          value={title}
        />
      </Box>
      <Box>
        <AHSeparator />
        <Box space="medium">
          <AHButton
            themeType="primary"
            title={intl_token.Save}
            onPress={onUpdateTitle}
            loading={loading}
          />
        </Box>
      </Box>
    </Box>
  );
}
